


























































































































import { Component, Vue } from "vue-property-decorator";
import CustomTable from "@/components/table.vue";
import { ConfirmModel, PaginationModel } from "@/api/types";
import AuthApi from "@/api/auth";
import ConfirmApi from "@/api/confirm";
import { Value } from "sass";
import moment from "moment";

@Component({
  components: {
    CustomTable,
  },
})
export default class Member extends Vue {
  data: ConfirmModel[] = [];
  pagination: PaginationModel & { total?: number } = {
    current: 1,
    pageSize: 10,
    keyword: "",
    keywordType: "",
  };

  authData = { auth: "" };

  authentificate = false;
  modalLoading = false;
  visible = false;
  adminMode = false;

  memberColumns = [
    // {
    //   width: 100,
    //   title: "순서",
    //   dataIndex: "id",
    // },
    {
      // width: 150,
      title: "이름",
      dataIndex: "name",
      scopedSlots: { customRender: "name" },
    },
    {
      // width: 200,
      align: "left",
      title: "전화번호",
      dataIndex: "phone",
      scopedSlots: { customRender: "phone" },
    },
    {
      // width: 200,
      align: "left",
      title: "이메일",
      dataIndex: "email",
      scopedSlots: { customRender: "email" },
    },
    {
      // width: 200,
      align: "left",
      title: "접수일",
      dataIndex: "registerDate",
      scopedSlots: { customRender: "registerDate" },
    },
    {
      align: "ceneter",
      title: "접수 현황",
      dataIndex: "status",
      scopedSlots: { customRender: "radio" },
    },
    {
      // width: 100,
      align: "right",
      title: "",
      dataIndex: "status",
      scopedSlots: { customRender: "status" },
    },
  ];


  dateFormat(date: Date) {
    return moment(date).format("yyyy-MM-DD HH:mm:ss");
  }

  send() {
    AuthApi.SendCode();
  }

  canceled() {
    location.href = "/";
  }

  async auth() {
    const result = await AuthApi.Auth(this.authData.auth);
    this.authentificate = result.result;
    localStorage.setItem("auth", this.authentificate.toString());
  }

  reset() {
    this.load();
  }

  moveOn(page: any) {
    this.pagination = page;
    this.load();
  }

  async reception(row: any) {
    let result = await ConfirmApi.status(row.memberCode, row.status);
    if(result.result == false){
      console.log(result.message);
      alert("오류가 발생했습니다. 관리자에게 문의해주세요.");
    } else {
      row.status = result.status;    
    }
  }

  async progress(row: any, activeKey: any){
    this.$router.push({ name: "memberDetail", query: { id: row.memberCode, activeKey: activeKey } });
  }

  async confirm(record: ConfirmModel) {
    await ConfirmApi.confirm(record.id);
    this.reset();
  }

  mounted() {
    this.authentificate = localStorage.getItem("auth") === "true";
    this.load();
  }

  async load() {
    let result = await ConfirmApi.list(this.pagination);
    this.data = [...result.data];
    this.pagination.total = result.totalCount;
    console.log(result.totalCount);
  }
  showModal() {
    this.visible = true;
  }
}

interface KeywordModel {
  value: string;
  title: string;
}
